import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';
import * as AccountActions from './account.actions';
import * as fromAccount from './account.reducers';
import * as AccountSelectors from './account.selectors';
import {
  IAccountAddress,
  IAccountProfile,
  IAddress
} from '@care-portals/api-interfaces';

@Injectable()
export class AccountFacade {
  accountState$ = this.store.pipe(select(AccountSelectors.getAccountState));
  accountConsultations$ = this.store.pipe(
    select(AccountSelectors.getConsultations)
  );
  accountAppointments$ = this.store.pipe(
    select(AccountSelectors.getAppointments)
  );
  accountAddress$ = this.store.pipe(select(AccountSelectors.getAddress));
  accountPrescriptions$ = this.store.pipe(
    select(AccountSelectors.getPrescriptions)
  );
  isLoading$ = this.store.pipe(select(AccountSelectors.isLoading));
  isShowAddPaymentMethod$ = this.store.pipe(
    select(AccountSelectors.isShowAddPaymentMethod)
  );

  accountProfile$ = this.store.pipe(select(AccountSelectors.getProfile));
  paymentMethods$ = this.store.pipe(select(AccountSelectors.getPaymentMethods));

  constructor(
    private store: Store<fromAccount.State>,
  ) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  addPaymentMethodAndAddress(paymentMethodId: string, address: IAddress) {
    this.dispatch(
      AccountActions.addPaymentMethodAndAddress({ paymentMethodId, address })
    );
  }

  addPaymentMethod(token: string, zip?: string) {
    this.dispatch(AccountActions.addPaymentMethod({ token, zip }));
  }

  removePaymentMethod(paymentMethodId: string) {
    this.dispatch(AccountActions.removePaymentMethod({ paymentMethodId }));
  }

  showAddPaymentMethod() {
    this.dispatch(AccountActions.showAddPaymentMethod());
  }

  editProfile(req: IAccountProfile) {
    this.dispatch(AccountActions.editProfile({ req }));
  }

  enableEditProfile() {
    this.dispatch(AccountActions.enableEditProfile());
  }

  cancelEditProfile() {
    this.dispatch(AccountActions.cancelEditProfile());
  }

  editAddress(req: IAccountAddress) {
    this.dispatch(AccountActions.editAddress({ req }));
  }

  enableEditAddress() {
    this.dispatch(AccountActions.enableEditAddress());
  }

  cancelEditAddress() {
    this.dispatch(AccountActions.cancelEditAddress());
  }

  changePassword(currentPassword: string, newPassword: string) {
    this.dispatch(
      AccountActions.changePassword({ currentPassword, newPassword })
    );
  }
}
